import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    semanticHeadLevel: {
      type: String,
      default: '1'
    },
    styleHeadLevel: {
      type: String,
      default: undefined
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'AppTitle'
    });
    return {
      __sfc: true,
      props: props
    };
  }
});